<template>
  <div>
    <div class="finance-header">
      <van-dropdown-menu active-color="#ee0a24">
        <van-dropdown-item :options="productList" :value="params.productId" @change="selectProduct" />
      </van-dropdown-menu>
      <van-field
        v-model="params.start"
        label="日期搜索"
        placeholder="请选择日期"
        @click="showDatePicker = true"
      />
    </div>

    <div class="finance-container">
      <p class="finance-title">
        <span>姓名</span>
        <span>单量</span>
        <span>保费</span>
      </p>
      <p class="finance-con" v-for="(item,idx) in dataList" :key="idx">
        <span>{{ item.nickName }}</span>
        <span>{{ item.insureCount }}</span>
        <span>{{ item.sumPremium }}元</span>
      </p>
    </div>

    <van-popup v-model="showDatePicker" position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        title="选择年月日"
        :min-date="minDate"
        :max-date="maxDate"
        @cancel="showDatePicker=false"
        @confirm="dateConfirm"
      />
    </van-popup>
  </div>
</template>

<script>
import { findProductList, findFinanceList } from '@/api/common';

export default {
  data() {
    return {
      productList: [],
      dataList: [],
      params: {
        productId: '',
        start: '',
        end: ''
      },
      currentDate: new Date(),
      minDate: new Date(2000, 0, 1),
      maxDate: new Date(),
      showDatePicker: false
    }
  },
  created() {
    findProductList().then(res => {
      if (res && res.code === 0) {
        this.productList = res.data.list.map(item => {
          item.text = item.name
          item.value = item.id
          return item
        })
        this.params.productId = res.data.list[0].id
        const yesterday = this.$DateTools.getDateByDay(-1)
        this.params.start = this.timeFormatter(yesterday)
        this.params.end = this.timeFormatter(yesterday)
        this.findDataList()
      }
    })
  },
  methods: {
    selectProduct(val) {
      this.params.productId = val
      this.findDataList()
    },
    dateConfirm() {
      this.params.start = this.timeFormatter(this.currentDate);
      this.params.end = this.timeFormatter(this.currentDate);
      this.showDatePicker = false;
      this.findDataList()
    },
    findDataList() {
      findFinanceList(this.params).then(res => {
        if (res && res.code === 0) {
          this.dataList = res.data.list
        }
      })
    },
    timeFormatter(timestamp) {
      const date = new Date(timestamp)//时间戳为10位需*1000，时间戳为13位的话不需乘1000
      const year = date.getFullYear()
      const month = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1)
      const day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
      return year + '-' + month + '-' + day
    }
  }
}
</script>

<style scoped lang="scss">
  .finance- {
    &header {
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      align-items: center;
    }

    &container {
      width: 100%;
      padding: .6rem;
    }

    &title, &con {
      display: flex;
      justify-content: space-around;
      align-items: center;
      line-height: 2.6rem;
      height: 2rem;
      font-size: 1.2rem;
      border-bottom: 1px solid #ececec;

      span {
        width: 33.3%;
        text-align: center;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }

    &con span {
      font-size: 1rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/insurance/static_list.vue